import { lazy } from "react";
import routerList from "./routerList";
import { Routes, Route, Navigate } from "react-router-dom";

import Carriers from "pages/Carriers";
import MarketplaceCarriers from "pages/MarketplaceCarriers/MarketplaceCarriers";
import NotFound from "pages/NotFound/NotFound";
import useUserRoles from "shared/hooks/useUserRoles";

const MapPage = lazy(() => import("../pages/Map/Map"));
const Users = lazy(() => import("../pages/Users/Users"));
const Dashboard = lazy(() => import("../pages/Dashboard/Dashboard"));
const CarrierEdit = lazy(() => import("../pages/CarrierEdit/CarrierEdit"));
const UserEdit = lazy(() => import("../pages/UserEdit/UserEdit"));
const Customers = lazy(() => import("../pages/Customers/Customers"));
const Locations = lazy(() => import("../pages/Locations/Locations"));
const CustomerEdit = lazy(() => import("../pages/CustomerEdit/CustomerEdit"));
const CoveragePlans = lazy(
  () => import("../pages/CoveragePlans/CoveragePlans")
);
const LocationEdit = lazy(
  () => import("../pages/Locations/LocationEdit/LocationEdit")
);
const RoutingGuideContainer = lazy(
  () => import("../pages/RoutingGuide/RoutingGuideContainer")
);
const RoutingGuideDetails = lazy(
  () => import("../pages/RoutingGuide/RoutingGuideDetails")
);
const RegionManager = lazy(
  () => import("../pages/RegionManager/RegionManager")
);

const Router = () => {
  const { isAdministrator } = useUserRoles();

  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to={routerList.carriers.list} replace />}
      />
      <Route
        path="/callback"
        element={<Navigate to={routerList.carriers.list} replace />}
      />
      {/*Dashboard*/}
      <Route path={routerList.dashboard} element={<Dashboard />} />
      {/*Carrier*/}
      <Route path={routerList.carriers.list} element={<Carriers />} />
      <Route path={routerList.carriers.details} element={<CarrierEdit />} />
      {/*Customer*/}
      <Route path={routerList.customers.list} element={<Customers />} />
      <Route path={routerList.customers.details} element={<CustomerEdit />} />
      {/*Carrier Marketplace*/}
      <Route
        path={routerList.marketplaceCarriers}
        element={<MarketplaceCarriers />}
      />
      {/*Map*/}
      <Route path={routerList.map} element={<MapPage />} />
      {/*Routing Guide*/}
      <Route
        path={routerList.routingGuide.list}
        element={<RoutingGuideContainer />}
      />
      <Route
        path={routerList.routingGuide.details}
        element={<RoutingGuideDetails />}
      />
      {/*Location*/}
      <Route path={routerList.locations.list} element={<Locations />} />
      <Route path={routerList.locations.details} element={<LocationEdit />} />
      {/*Coverage Plans*/}
      <Route path={routerList.coveragePlans} element={<CoveragePlans />} />
      {/*Users*/}
      {isAdministrator && (
        <>
          <Route path={routerList.users.list} element={<Users />} />
          <Route path={routerList.users.details} element={<UserEdit />} />
        </>
      )}
      <Route path={routerList.regionManager} element={<RegionManager />} />
      {/*Not Found*/}
      <Route path={routerList.notFound} element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Router;
